import { flatbizDate } from '@flatbiz/utils';
import { hooks } from '@wove/react';
import { useMemo, useState } from 'react';
type TDate = Date | number | string;

export type UseCountdownParam = {
  targetDate: Date | number | string;
  onEnd?: () => void;
};

export interface UseCountdownFormattedRes {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  milliseconds: number;
}

const diffValue = (t: TDate) => {
  if (!t) {
    return 0;
  }
  const left = new Date(t).getTime() - new Date().getTime();
  if (left < 0) {
    return 0;
  }
  return left;
};

const parseMs = (milliseconds: number): UseCountdownFormattedRes => {
  return {
    days: Math.floor(milliseconds / 86400000),
    hours: Math.floor(milliseconds / 3600000) % 24,
    minutes: Math.floor(milliseconds / 60000) % 60,
    seconds: Math.floor(milliseconds / 1000) % 60,
    milliseconds: Math.floor(milliseconds) % 1000,
  };
};

/**
 * 倒计时
 * @param options
 * @returns
 */
export const useCountdown = (options: UseCountdownParam) => {
  const { targetDate, onEnd } = options || {};

  const [timeLeft, setTimeLeft] = useState(() => diffValue(targetDate));

  const onEndRef = hooks.useCallbackRef(onEnd);

  const targetDateCompare = hooks.useCallbackRef((a, b) => {
    //
    if (!b || !flatbizDate.eq(a[0], b[0])) {
      return false;
    }
    return true;
  });

  hooks.useCustomCompareEffect(
    () => {
      if (!targetDate) {
        setTimeLeft(0);
        return;
      }
      // 立即执行一次
      setTimeLeft(diffValue(targetDate));

      const timer = setInterval(() => {
        const targetLeft = diffValue(targetDate);
        setTimeLeft(targetLeft);
        if (targetLeft === 0) {
          clearInterval(timer);
          onEndRef?.();
        }
      }, 1000);

      return () => clearInterval(timer);
    },
    [targetDate],
    targetDateCompare,
  );

  const formattedRes = useMemo(() => {
    return parseMs(timeLeft);
  }, [timeLeft]);

  return formattedRes;
};
